import FormatDateTimeRange from 'components/utils/Formatters/FormatDateTimeRange'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { LUX_PLUS_MONTH_TAKEOVER_START_DATE, LUX_PLUS_MONTH_TAKEOVER_END_DATE, LUX_PLUS_MONTH_HIGHLIGHT_BLUE } from '../constants/luxPlusMonthTakeoverConstants'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'
import Label from 'LuxKit/Label'

const SinfulLabel = styled(Label)`
  &&& {
    border-color: ${props => props.theme.palette.neutral.default.one};
  }
`

const CustomColour = styled.b`
  color: ${LUX_PLUS_MONTH_HIGHLIGHT_BLUE};
`

function LuxPlusMonthHeroSubtitleAltContent() {
  const intl = useIntl()
  const monthLabel = intl.formatMessage({
    id: '4_NLDG__ytvK_dj2fWXz',
    defaultMessage: 'Month',
    description: 'Campaign month label in LuxPlus+ Month badge in hero subtitle',
  })

  return <FormattedMessage
    id="aO-e6NjEgOJVJNSUe7z7"
    defaultMessage="Look for {luxPlusMonthLabel} on select packages from {dateRange}"
    description="Hero subtitle describing where to find LuxPlus+ Month offers with campaign dates"
    values={{
      luxPlusMonthLabel: <SinfulLabel kind="primary" variant="lux-plus-month"><LuxPlusLogo colour="inherit" height={9} /> {monthLabel}</SinfulLabel>,
      dateRange: <CustomColour><FormatDateTimeRange startValue={LUX_PLUS_MONTH_TAKEOVER_START_DATE} endValue={LUX_PLUS_MONTH_TAKEOVER_END_DATE} day="numeric" month="long" /></CustomColour>,
    }}
  />
}

export default LuxPlusMonthHeroSubtitleAltContent
